import type { Guide } from '../types';

/** S-24.10-08 — pulpit Team Leadera: bilans floty, postęp planistów, deficyt i nadwyżka (scenariusz e2e 29). */
export const guide: Guide = {
  flagKey: 'teamLeaderBalance',
  title: 'Pulpit Team Leadera: bilans floty, postęp planistów, deficyt i nadwyżka',
  whatItDoes:
    'Pod kafelkami pulpitu Team Leadera dwie tabele. „Bilans floty i postęp planistów” — wiersz na każdego opiekuna FTL, „bez opiekuna” i cała flota: pojazdy, wolne teraz i za 6, 12, 24 h, pojazdy z planem sięgającym poza jutro i zlecenia z wariantem czekającym na decyzję. „Deficyt i nadwyżka według kraju załadunku” — zlecenia gotowe i wstępnie planowane bez pojazdu z załadunkiem w horyzoncie (wartość robocza 48 h) wobec pojazdów, które w tym czasie zwalniają się w tym kraju albo tam stoją. Liczby to szacunek, bez wózków i aut poza planowaniem; liczba prowadzi do harmonogramu floty albo listy zleceń z tym samym filtrem.',
  audience: ['Team Leader (planista główny)', 'administrator'],
  presentationItems: ['S-24.10-08'],
  steps: [
    {
      route: '/ftl-team-leader-dashboard',
      target: 'tl-balance-fleet',
      title: 'Bilans floty i postęp planistów',
      description:
        'Wiersz na każdego opiekuna FTL: ile ma pojazdów, ile jest wolnych teraz i za 6, 12 i 24 godziny, ile ma plan sięgający poza jutro i przy ilu zleceniach czeka wariant jego pojazdu. Na dole cała flota.',
      action: 'Otwórz „Pulpit Team Leadera” i kliknij liczbę „Wolne teraz” przy opiekunie — otworzy się harmonogram floty jego pojazdów.',
      recorder: { account: 'master' },
    },
    {
      route: '/ftl-team-leader-dashboard',
      target: 'tl-balance-regions-section',
      title: 'Deficyt i nadwyżka według kraju załadunku',
      description:
        'Dla każdego kraju: zlecenia do obsadzenia z załadunkiem w horyzoncie i pojazdy, które w tym czasie się tam zwalniają. Chip mówi: deficyt, nadwyżka albo równo. Horyzont zmienia się w „Parametrach rekomendacji”.',
      action: 'Kliknij liczbę zleceń przy kraju — lista zleceń otworzy się z filtrem kraju i horyzontu.',
      recorder: { account: 'master' },
    },
  ],
};
